import React, { useState, useEffect } from "react";
import editicon from "../../../assets/images/icons/edit.svg";
import removeicon from "../../../assets/images/icons/remove.svg";
import searchicon from "../../../assets/images/icons/search-normal.svg";
import { Table } from "reactstrap";
import IconButton from "../../../assets/elements/IconButton";
import Pagination from "../../../assets/elements/CustomPagination";
import SuccessModal from "../../../assets/elements/SuccessModal";
import "./securityPermission.scss";
import { InputGroup, Form, Button, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomErrorMessage from "../../../assets/elements/ErrorMessage";
import { squareBackIcon } from "../../../assets/images/icons/icons";
import useCurrentPage from "../../../hooks/useCurrentPage";
import accessRole_reset from "../../../assets/images/icons/reseticon.svg";
import axios from "axios";
import PageLoader from "../../../assets/loaders/PageLoading";
import MainServices from "../../../services/MainServices";
import { notifyWarn, notifySuccess } from "../../../assets/elements/Toast";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import TimingFunctions from "../../../assets/functions/TimingFunctions";
import ButtonLoading from "../../../assets/loaders/ButtonLoading";
import { PrimaryInput } from "../../../assets/FormElements";
import PermissionFunctions from "../../../assets/functions/PermissionFunctions";
import {
  paramsToFilters,
  paramsToFiltersObj,
  filtersToUri,
  filtersToUrlParams,
} from "../../../assets/functions/filters";
import Select from "react-select";
import { PrimaryButton } from "../../../assets/buttons";
import useFeatureSetting from "../../../hooks/useFeatureSetting";

const allStatus = [
  { label: "All", value: "" },
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
];

const staticData = [
  { role: "Admin", description: "Administrator role", createdAt: "2024-02-29" },
  { role: "User", description: "Regular user role", createdAt: "2024-02-28" },
];

const SecurityPermission = () => {
  const navigate = useNavigate();
  const [successModal, setSuccessModal] = useState();
  const [successType, setSuccessType] = useState();
  const [editAccessRoleModal, setEditAccessRoleModal] = useState(false);
  const [deleteAccessRoleModal, setDeleteAccessRoleModal] = useState(false);
  const [accessRoles, setAccessRoles] = useState([]);
  const [totalAccessRoles, setTotalAccessRoles] = useState(0);
  const [pageLoading, setPageLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const { updateCurrentPage } = useCurrentPage();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const location = useLocation();
  const [selectedAccessRole, setSelectedAccessRole] = useState([]);
  const [selectedSecurityGroup, setSelectedSecurityGroup] = useState([]);
  const [permissionMenu, setPermissionMenu] = useState([]);
  const [securityGroupPermissions, setSecurityGroupPermissions] = useState([]);
  const { deBounce } = TimingFunctions();
  const { grantPermission } = PermissionFunctions();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
  });
  const [searchString, setSearchString] = useState("");
  const [filters, setFilters] = useState({});
  const [tools, setTools] = useState([]);
  const [selectedEmployee, setselectedEmployee] = useState({});
  const [addEmployeeModal, setaddEmployeeModal] = useState(false);
  const [securityGroups, setSecurityGroups] = useState([]);
  const { updateSettingContext, setting } = useFeatureSetting();

  //url Params
  const params = new URLSearchParams(location.search);
  const changedParams = Object.fromEntries(params);

  const accessRoleSchema = Yup.object().shape({
    security_group_name: Yup.string().required("Enter Security Group"),
    permissions: Yup.array()
      .min(1, "Select roles")
      .required("Permission's are mandatory!"),
  });

  useEffect(() => {
    updateSettingContext("security-group");
  }, []);

  const {
    getRoleMasters,
    getSecurityGroupPermissionMaster,
    addSecurityGroupPermissionMaster,
    updateSecurityGroupPermissionMaster,
    deleteSecurityGroupPermissionMaster,
    getAllPermission,

    getToolsAccess,
    getSecurityGroupMaster,
  } = MainServices();

  useEffect(() => {
    updateCurrentPage({
      title: "Security Permissions",
      subtitle: "",
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getTools();
    getSecurityGroups();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let selectOptions = [{ value: "all", label: "all", key: "all" }];
    let available = setting.available_status || [];
    available.map((each) => {
      selectOptions.push({ value: each, label: each, key: "status" });
    });
    let record = setting.record_status || [];
    record.map((each) => {
      selectOptions.push({ value: each, label: each, key: "record_status" });
    });
    setSelectOptions(selectOptions);
  }, [setting]);

  useEffect(() => {
    let filters = paramsToFilters(changedParams?.filters, "filters");
    let filtersObj = paramsToFiltersObj(changedParams?.filters);
    // setSelectedStatus(filtersObj?.status?.status || "");
    // setSearchString(filtersObj?.name?.name);
    setFilters(filtersObj);
    setSearchString(changedParams?.searchString);

    getSecurityGroupPermissionMasterByStatus({
      page: pagination.page,
      limit: pagination.limit,
      filters,
      searchString: changedParams?.searchString,
    });
    // eslint-disable-next-line
  }, [
    changedParams.page,
    changedParams.limit,
    changedParams.filters,
    changedParams?.searchString,
  ]);

  // const onAddSecurityGroup = (selected) => {
  //   if (selected) {
  //     setselectedEmployee(selected);
  //   } else {
  //     setselectedEmployee("");
  //   }
  //   setaddEmployeeModal(!addEmployeeModal);
  // };

  const onAddSecurityGroup = (selected) => {
    setEditAccessRoleModal(false);
  };

  //apis
  const getSecurityGroups = async () => {
    const details = {
      status: "ACTIVE",
    };
    await axios
      .all([getSecurityGroupMaster(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData.message;
          if (resData.success) {
            let securityGroups = resData?.data || [];
            securityGroups = securityGroups.map((each) => {
              return {
                ...each,
                label: each?.securityGroupName,
                value: each?.publicId,
              };
            });
            setSecurityGroups(securityGroups);
          } else {
            if (message) notifyWarn(message);
          }
        } else {
        }
      })
      .catch(function (res) {
        if (res.message)
          console.log("An error occurred in getting Designations");
      });
  };

  const getPermissionsBySecuirtyGroup = async (filters) => {
    setModalLoading(true);
    const details = {
      filters,
      pageNumber: 1,
      pageSize: 100,
    };
    await axios
      .all([getSecurityGroupPermissionMaster(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let securityGroupPermissions = resData.data ? resData.data : [];
            securityGroupPermissions = securityGroupPermissions.map(
              (_) => _.permissionId
            );
            setSecurityGroupPermissions(securityGroupPermissions);
            setModalLoading(false);
          } else {
            setModalLoading(false);
          }
        } else {
          setModalLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in getting Permissions");
      });
  };

  const getPermissionsList = async (tool) => {
    setModalLoading(true);
    const details = {
      ...(tool ? { filters: [{ key: "source", eq: tool }] } : {}),
    };
    await axios
      .all([getAllPermission(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let roles = resData.data ? resData.data : {};
            roles = roles.reduce(
              (result, item) => ({
                ...result,
                [item?.operationId || undefined]: {
                  ...item?.operation,
                  permissions: [
                    ...(result[item?.operationId]?.permissions || []),
                    {
                      ...item,
                      checked: false,
                    },
                  ],
                },
              }),
              {}
            );
            let modifedPermissions = Object.keys(roles).map((key) => {
              return {
                ...roles[key],
              };
            });
            setPermissionMenu(modifedPermissions);
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in getting Permissions");
      });
  };

  const getSecurityGroupPermissionMasterByStatus = async ({
    page,
    limit,
    filters,
    searchString,
  }) => {
    setPageLoading(true);
    const details = {
      pageSize: limit || 20,
      pageNumber: page || 1,
      filters,
      searchString,
    };
    await axios
      .all([getSecurityGroupMaster(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let role = resData.data ? resData.data : [];
            let total = resData?.totalCount || 0;
            setTotalAccessRoles(total);
            role = role.map((_, index) => {
              return {
                ..._,
                sNo: rowsPerPage * (page - 1) + index + 1,
              };
            });
            setSecurityGroups(role);
            setPageLoading(false);
          } else {
            setPageLoading(false);
          }
        } else {
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in getting Roles");
      });
  };

  const addSecurityGroupPermission = async (values) => {
    setButtonLoading(true);
    let permissions = values?.permissions || [];
    permissions = permissions.map((_) => {
      return {
        permissionId: _,
        status: "active",
      };
    });

    const details = {
      role: values?.role_name,
      permissions: permissions,
    };
    await axios
      .all([addSecurityGroupPermissionMaster(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            getSecurityGroupPermissionMasterByStatus({
              page: pagination.page,
              limit: pagination.limit,
              filters,
            });
            handleEditClick();
            notifySuccess("Security Permission Added Successfully");
            setButtonLoading(false);
          } else {
            message && notifyWarn(message);
            setButtonLoading(false);
          }
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in adding Security Permission");
      });
  };

  const updateSecurityGroupPermission = async (values) => {
    setButtonLoading(true);
    let permissions = values?.permissions || [];

    const details = {
      permissions,
      security_group_id: selectedSecurityGroup.publicId,
    };

    await axios
      .all([
        updateSecurityGroupPermissionMaster(
          details,
          selectedAccessRole.publicId,
          selectedAccessRole.concurrencyStamp
        ),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData.message;
          if (resData.success) {
            getSecurityGroupPermissionMasterByStatus({
              page: pagination.page,
              limit: pagination.limit,
              filters,
            });
            handleEditClick();
            notifySuccess("Security Permission Updated Successfully");
            setButtonLoading(false);
          } else {
            message && notifyWarn(message);
            setButtonLoading(false);
          }
        } else {
          setButtonLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in updating Security Permission");
      });
  };

  const deleteSecurityGroupPermission = async () => {
    setButtonLoading(true);
    const details = {
      status: "inactive",
    };
    await axios
      .all([
        deleteSecurityGroupPermissionMaster(
          details,
          selectedAccessRole.publicId,
          selectedAccessRole.concurrencyStamp
        ),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            getSecurityGroupPermissionMasterByStatus({
              page: pagination.page,
              limit: pagination.limit,
              filters,
            });
            handleDeleteClick();
            notifySuccess("Security Permission Deleted Successfully");
            setButtonLoading(false);
          } else {
            message && notifyWarn(message);
            setButtonLoading(false);
          }
        } else {
          setButtonLoading(false);
        }
      })
      .catch(function (res) {
        if (res.message)
          console.log("An error occurred in deleting Security Permission");
      });
  };

  const getTools = async () => {
    const details = {
      pageSize: 20,
      pageNumber: 1,
    };
    await axios
      .all([getToolsAccess(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let tools = resData.data ? resData.data : [];
            setTools(tools);
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message) console.log("An error occurred in getting Location");
      });
  };

  //functions
  const handleEditClick = async (selected, tool) => {
    setSecurityGroupPermissions([]);
    setEditAccessRoleModal(!editAccessRoleModal);
    if (selected) {
      let filters = [
        {
          key: "securityGroupId",
          eq: selected.publicId,
        },
      ];
      if (tool) {
        await getPermissionsList(tool);
        getPermissionsBySecuirtyGroup(filters);
      } else {
        setPermissionMenu([]);
        setSecurityGroupPermissions([]);
      }
      selected.source = tool;
      setSelectedSecurityGroup(selected);
    } else {
      setSelectedSecurityGroup("");
      setPermissionMenu([]);
      setSecurityGroupPermissions([]);
    }
  };

  const onDeleteAccessRole = (selected) => {
    if (selected) {
      setSelectedSecurityGroup(selected);
    } else {
      setSelectedSecurityGroup("");
    }
    setDeleteAccessRoleModal(!deleteAccessRoleModal);
  };

  const handleCloseEditModal = () => {
    setEditAccessRoleModal(false);
  };

  const handleDeleteClick = () => {
    // setDeleteAccessRoleModal(!deleteAccessRole);
    setDeleteAccessRoleModal(!deleteAccessRoleModal);
  };

  const handleResetButton = (resetForm, setFieldValue) => {
    resetForm();
    setFieldValue("access", []);
  };

  const onStatusChange = (selectedOption) => {
    const e = selectedOption || { value: "all", key: "all" };
    let value = e.value;
    const { record_status, status, ...remaining } = filters;
    let mfilters = filtersToUri({
      ...remaining,
      ...(value === "all"
        ? {}
        : e.key === "record_status"
        ? {
            record_status: { record_status: value },
            status: { status: "approved" },
          }
        : { status: { status: value } }),
    });
    setSelectedStatus(selectedOption ? { label: value, value: value } : null);
    let search = filtersToUrlParams({
      page: pagination.page,
      limit: pagination.limit,
      filters: mfilters,
    });
    navigate({
      search,
    });
  };

  //pagination
  const onPage = (page) => {
    let mfilters = filtersToUri(filters);
    let search = filtersToUrlParams({
      page,
      limit: pagination.limit,
      filters: mfilters,
      searchString,
    });
    navigate({ search });
  };

  const onRowsPerPage = (rows) => {
    let mfilters = filtersToUri(filters);
    let search = filtersToUrlParams({
      page: pagination.page,
      limit: rows,
      filters: mfilters,
      searchString,
    });
    navigate({ search });
  };

  const searchTraining = (e) => {
    let raw = e?.target?.value || "";
    if (raw === " " || (searchString === "" && raw.startsWith(" "))) {
      return;
    }
    raw = raw.replace(/^\s+/, "");
    setSearchString(raw);
    deBounce(() => onSearchFilter(raw), 1000);
  };

  const onSearchFilter = (value) => {
    const normalizedValue = value.trim().replace(/\s+/g, " ");

    let mfilters;
    if (normalizedValue && normalizedValue.length > 0) {
      mfilters = filtersToUri({
        ...filters,
        securityGroupName: { securityGroupName: normalizedValue },
      });
    } else {
      const filtersWithoutName = { ...filters };
      if (filtersWithoutName && filtersWithoutName.securityGroupName) {
        delete filtersWithoutName.securityGroupName;
      }
      mfilters = filtersToUri(filtersWithoutName);
    }

    let search = filtersToUrlParams({
      page: 1,
      limit: 20,
      filters: mfilters,
      searchString: normalizedValue,
    });
    navigate({
      search,
    });
  };

  return (
    <div className="admin-popular-main security-permission-page">
      <SuccessModal
        modal={successModal}
        setModal={setSuccessModal}
        message="Feature Service"
        type={successType}
      />

      <div className="header">
        <p className="content-header-main">
          Security Permission {pageLoading ? "" : `(${totalAccessRoles || 0})`}
        </p>
        <div className="d-flex gap-3">
          <InputGroup style={{ width: "auto" }}>
            <Form.Control
              placeholder="Search "
              aria-label="Search"
              aria-describedby="search"
              className="search-input-main"
              value={searchString}
              onChange={(e) => searchTraining(e)}
            />
            <InputGroup.Text id="search" className="search-input-main">
              <img src={searchicon} alt="search icon" />
            </InputGroup.Text>
          </InputGroup>

          <div className="product-list-header-flex">
            <Select
              className="custom-status-select"
              classNamePrefix="custom-status-select"
              name="status"
              onChange={onStatusChange}
              value={selectedStatus}
              options={selectOptions}
              isClearable
              placeholder="All"
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#00c2a8",
                  primary75: "rgba(0,194,168,0.75)",
                  primary50: "rgba(0,194,168,0.3)",
                  primary25: "rgba(0,194,168,0.12)",
                },
              })}
              styles={{
                option: (base, { isSelected }) => ({
                  ...base,
                  color: isSelected ? "#ffffff" : "var(--text-body, #4a5568)",
                  fontWeight: isSelected ? 700 : 500,
                }),
              }}
            />
          </div>

          {/* {grantPermission("SecurityGroupPermission_write") && (
            <IconButton
              iconType="add"
              title="Security Permission"
              onClick={() => handleEditClick("")}
            />
          )} */}
        </div>
      </div>
      {pageLoading ? (
        <PageLoader />
      ) : securityGroups && securityGroups.length > 0 ? (
        <div className="content">
          <div className="table-main">
            <Table responsive bordered className="table table-bordered">
              <thead className="service-table-head">
                <tr>
                  <th>Sr.No.</th>
                  <th>Security Group Name</th>
                  <th>Department</th>
                  <th>Description</th>
                  <th>Status</th>
                  {/* {grantPermission("AccessRight_update") && <th>Action</th>} */}
                  {grantPermission("SecurityGroupPermission_update") && (
                    <th>Action</th>
                  )}
                  {grantPermission("SecurityGroupPermission_delete") && (
                    <th>Delete</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {securityGroups.map((each, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{each?.securityGroupName}</td>
                      <td>{each?.deptartment?.deptName}</td>
                      <td>{each.description}</td>
                      <td>{each.status}</td>

                      {/* {grantPermission("SecurityGroupPermission_update") && (
                        <td className="options">
                          <div className="d-flex gap-2">
                            {tools.map((eachTool, toolIndex) => (
                              <div
                                key={toolIndex}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleEditClick(each, eachTool.name);
                                }}
                              >
                                <img src={editicon} alt="Edit icon" />
                                <span>{eachTool.name}</span>
                              </div>
                            ))}
                          </div>
                        </td>
                      )} */}
                      {(grantPermission("SecurityGroupPermission_update") ||
                        grantPermission("SecurityGroupPermission_delete")) && (
                        <td className="options">
                          <div className="d-flex gap-2">
                            {tools.map((eachTool, toolIndex) => (
                              <div
                                key={toolIndex}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleEditClick(each, eachTool.name);
                                }}
                              >
                                <img src={editicon} alt="Edit icon" />
                                <span>{eachTool.name}</span>
                              </div>
                            ))}
                          </div>
                        </td>
                      )}
                      {grantPermission("SecurityGroupPermission_delete") && (
                        <td className="options">
                          <div className="d-flex gap-2">
                            {!each.master && (
                              <div style={{ cursor: "pointer" }}>
                                <img
                                  src={removeicon}
                                  alt="Remove icon"
                                  onClick={() => onDeleteAccessRole(each)}
                                />
                              </div>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {/* <Table responsive bordered className="table table-bordered">
              <thead className="service-table-head">
                <tr>
                  <th>Sr.No.</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Created At</th>
                  {grantPermission("AccessRight_update") && <th>Action</th>}
                  {grantPermission("AccessRight_delete") && <th>Delete</th>}
                </tr>
              </thead>
              <tbody>
                {accessRoles &&
                  accessRoles.map((each, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{each?.role}</td>
                        <td>{each?.description}</td>
                        <td>
                          {moment(each?._id?.createdAt).format("DD.MM.YYYY")}
                        </td>
                        {(grantPermission("AccessRight_update") ||
                          grantPermission("AccessRight_delete")) && (
                          <td className="options">
                            <div className="d-flex gap-2">
                              {grantPermission("AccessRight_update") &&
                                tools &&
                                tools.length > 0 &&
                                tools.map((eachTool) => (
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      handleEditClick(each, eachTool.name);
                                    }}
                                  >
                                    <img src={editicon} alt="Edit icon" />
                                    <span>{eachTool.name}</span>
                                  </div>
                                ))}
                            </div>
                          </td>
                        )}
                        {grantPermission("AccessRight_update") && (
                          <td className="options">
                            <div className="d-flex gap-2">
                              {each?._id?.master ? (
                                <></>
                              ) : (
                                grantPermission("AccessRight_delete") && (
                                  <div style={{ cursor: "pointer" }}>
                                    <img
                                      src={removeicon}
                                      alt="Remove icon"
                                      onClick={() => onDeleteAccessRole(each)}
                                    />
                                  </div>
                                )
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </Table> */}
          </div>
        </div>
      ) : (
        <div className="no-data-found-main">No Security Permission Found</div>
      )}
      {securityGroups && securityGroups.length > 0 && (
        <div class="custom-pagination-main">
          <div class="card-inner">
            <Pagination
              totalCount={totalAccessRoles}
              currentPage={pagination.page}
              rowsPerPage={pagination.limit}
              onNext={onPage}
              onPrev={onPage}
              onPageClick={onPage}
              onRowsPerPage={onRowsPerPage}
            />
          </div>
        </div>
      )}
      <div className="add-sop-card-flex">
        <Modal
          centered
          size="lg"
          show={editAccessRoleModal}
          onHide={() => handleCloseEditModal()}
          className="add-department-modal-main workflow-model"
        >
          <Modal.Header closeButton className="add-department-modal-header">
            <Modal.Title className="add-department-modal-title">
              {selectedAccessRole ? "Update " : "Add "} Security Group
              Permissions
            </Modal.Title>
          </Modal.Header>
          {modalLoading ? (
            <PageLoader />
          ) : (
            <Modal.Body className="add-department-modal-body">
              {permissionMenu.length > 0 ? (
                <Formik
                  initialValues={{
                    security_group_name:
                      selectedSecurityGroup?.securityGroupName || "",
                    permission_data:
                      selectedSecurityGroup?.permissions || permissionMenu,
                    permissions: securityGroupPermissions || [],
                  }}
                  onSubmit={(values) => {
                    selectedSecurityGroup
                      ? updateSecurityGroupPermission(values)
                      : addSecurityGroupPermission(values);
                  }}
                  validationSchema={accessRoleSchema}
                >
                  {({
                    values,
                    handleSubmit,
                    handleBlur,
                    handleChange,
                    setFieldValue,
                    errors,
                    touched,
                    resetForm,
                  }) => (
                    <Form className="form" onSubmit={handleSubmit}>
                      <PrimaryInput
                        type="text"
                        className="form-control"
                        id="security_group_name"
                        name="security_group_name"
                        placeholder="Enter Role"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.security_group_name}
                        disabled={selectedSecurityGroup}
                      />
                      <CustomErrorMessage
                        name="security_group_name"
                        errors={errors}
                        touched={touched}
                      />
                      <div className="content">
                        <div className="table-main">
                          <Table
                            responsive
                            bordered
                            className="table custom-table"
                          >
                            <thead className="service-table-head">
                              <tr>
                                <th>Menu</th>
                                <th className="head-operations">View</th>
                                <th className="head-operations">Create</th>
                                <th className="head-operations">Modify</th>
                                <th className="head-operations">Delete</th>
                              </tr>
                            </thead>
                            <tbody className="custom-table-body">
                              {values.permission_data &&
                                values.permission_data.length > 0 &&
                                values.permission_data.map((each, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="operation-text">
                                        {each?.operationName?.replace(
                                          /_/g,
                                          " "
                                        )}
                                      </td>
                                      {each.permissions &&
                                        each.permissions.length > 0 &&
                                        each.permissions.map((_) => {
                                          return (
                                            <td className="options">
                                              <input
                                                type="checkbox"
                                                checked={values?.permissions?.includes(
                                                  _.publicId
                                                )}
                                                onChange={() => {
                                                  let data =
                                                    values?.permissions || [];
                                                  if (
                                                    data.includes(_?.publicId)
                                                  ) {
                                                    data = data.filter((e) => {
                                                      return (
                                                        e !== `${_?.publicId}`
                                                      );
                                                    });
                                                  } else {
                                                    data.push(_?.publicId);
                                                  }

                                                  setFieldValue(
                                                    "permissions",
                                                    data
                                                  );
                                                }}
                                              />
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  );
                                })}
                            </tbody>
                            {console.log("values", values?.permissions)}
                          </Table>
                          <CustomErrorMessage
                            name="permissions"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <div className="d-flex gap-2">
                          {selectedSecurityGroup ? (
                            <></>
                          ) : (
                            <>
                              <Button
                                className="back-icon-btn-main"
                                onClick={() =>
                                  handleResetButton(resetForm, setFieldValue)
                                }
                              >
                                <img src={accessRole_reset} />
                                <span className="ms-2">Reset</span>
                              </Button>
                            </>
                          )}

                          <PrimaryButton
                            className="theme-btn-main"
                            type="submit"
                            title={
                              buttonLoading ? (
                                <ButtonLoading />
                              ) : selectedSecurityGroup ? (
                                "Submit"
                              ) : (
                                "Submit"
                              )
                            }
                          />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              ) : (
                <p className="text-center">No Opertaions Found</p>
              )}
            </Modal.Body>
          )}
        </Modal>
      </div>
      <Modal
        centered
        show={deleteAccessRoleModal}
        onHide={onDeleteAccessRole}
        className="add-department-modal-main role-delete-model"
        selected={selectedSecurityGroup}
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            Delete Role
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="add-department-modal-body">
          <p>
            Do you want to delete this Role{" "}
            <span style={{ color: "#9d72ff", textDecoration: "underline" }}>
              {selectedAccessRole?.role}
            </span>
            ?
          </p>
          <div className="mt-3">
            <div className="d-flex gap-2">
              <Button
                className="back-icon-btn-main"
                onClick={onDeleteAccessRole}
              >
                <span>{squareBackIcon}</span>
                <span className="ms-2">Back</span>
              </Button>
              <PrimaryButton
                className="theme-btn-main"
                onClick={deleteSecurityGroupPermission}
                title={buttonLoading ? <ButtonLoading /> : "Delete"}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SecurityPermission;
